<template>
<div class="chapter">
<div class="inner_page">
<p class="deda"><span class="txit">For Gene Andrews,</span></p>
<p class="ded"><span class="txit">who so wanted to keep his sister’s work alive</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?677a3d94